var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","stroke":"#37a9fb","strokeWidth":"4","x":"25","y":"25","width":"50","height":"50","key":0},React.createElement("animateTransform",{"attributeName":"transform","dur":"0.5s","from":"0 50 50","to":"180 50 50","type":"rotate","id":"strokeBox","attributeType":"XML","begin":"rectBox.end"})),React.createElement("rect",{"x":"27","y":"27","fill":"#37a9fb","width":"46","height":"50","key":1},React.createElement("animate",{"attributeName":"height","dur":"1.3s","attributeType":"XML","from":"50","to":"0","id":"rectBox","fill":"freeze","begin":"0s;strokeBox.end"}))]);
}

Loader.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Loader;

Loader.default = Loader;
